<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
        <p-accordionTab header="{{ 'CONFIGURACIONCANALESESTADO.LBL_CONFIGCANALESTADO' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCanales" name="fCanales">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_CANAL' | translate }}</label>
                  <p-dropdown disableTab  id="idFormulario" name="nomCanal" [options]="listaCanales" filter="filter" *ngIf="!configCanal"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionLabel="label" optionValue="value"
                               formControlName="idCanal"
                  ></p-dropdown>
                  <label class="falso-combo-texto" *ngIf="configCanal" >{{nombreCanal}}</label>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idCanal.invalid">
                    {{ 'CONFIGURACIONCANALESESTADO.LBL_CANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_ESTADO' | translate }}</label>
                  <p-dropdown disableTab  id="idEstado" name="nomEstado" [options]="listaEstados" filter="filter" *ngIf="!configCanal"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionLabel="label" optionValue="value"
                               formControlName="idEstado"
                  ></p-dropdown>
                  <label class="falso-combo-texto" *ngIf="configCanal">{{nombreEstado}}</label>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idEstado.invalid">
                    {{ 'CONFIGURACIONCANALESESTADO.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_SECCION' | translate }}</label>
                  <p-dropdown disableTab  id="idSeccion" name="nomSeccion" [options]="listaSecciones" filter="filter"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionLabel="label" optionValue="value"
                               formControlName="idSeccion" (onChange)="cargarControles($event.value)"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idSeccion.invalid">
                    {{ 'CONFIGURACIONCANALESESTADO.LBL_SECCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_CONTROL' | translate }}</label>
                  <p-dropdown disableTab  id="idControl" name="nomControl" [options]="listaControles" filter="filter"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionLabel="label" optionValue="value"
                               formControlName="idControl"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idControl.invalid">
                    {{ 'CONFIGURACIONCANALESESTADO.LBL_CONTROL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CONFIGURACIONCANALESESTADO.LBL_HABILITADO' | translate}}" binary="true"
                            id="indicador"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'CONFIGURACIONCANALESESTADO.LBL_SELECCIONPASOS' | translate }}" [selected]="tabSeleccionado === 'PASOS'" [disabled]="!configCanal">
          <!-- COLOCAR LA SECCION DE SELECCION DE PASOS-->
          <app-canal-estado-paso *ngIf="configCanal" [configuracionCanal]="configCanal" [editar]="true"></app-canal-estado-paso>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="configCanal && configCanal.idConfiguracionCanal">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="canal-estado">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
